<template>
  <div>
    <div class="no-auth">
      非常抱歉，您没有权限访问。
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/theme/app.scss';

  .no-auth {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white-color;
    font-size: 1.2rem;
  }
</style>
